import React, { Component } from "react";
import FormStep from "../../common/components/formStep";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import commonContext, { AppContext } from "../../common/context/common";
import BackContinueButton from "../../common/components/pageBlocks/backContinueButton";
import EmploymentDetailsCard from "../../common/components/pageBlocks/personalDetails/employmentDetailsCard";
import PersonalDetailsCard from "../../common/components/pageBlocks/personalDetails/personalDetailsCard";
import { leadType } from "../../app";
import { ALDDApis } from "../apis/aLDDApis";

interface IProps {
    history: any;
}
interface IState {}
class PersonalDetails extends Component<IProps, IState> {
    static contextType = commonContext;
    setLead: Function;
    lead: leadType;
    apis: ALDDApis;
    steps = [
        { title: "Vehicle" },
        { title: "Loan" },
        { title: "Personal", active: true },
        { title: "e-Mandate" },
        { title: "Confirmation" },
    ];
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.setLead = (this.context as AppContext).setLead;
        this.lead = (this.context as AppContext).lead as leadType;
    }
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        this.apis = (this.context as AppContext).apis as ALDDApis;
        let step = this.lead.step == 3 ? this.lead.step : ++this.lead.step;
        const apiData = await this.apis.savePersonalDetails({
            ...this.lead,
            step: step,
        });
        if (!apiData.error?.error) {
            this.props.history.push("/error");
        }
        if (!apiData.result?.error) {
            this.setLead({ step: step });
            if (this.lead.typeOfCustomer == "ETB") {
                return this.props.history.push("declaration");
            }
            this.props.history.push("e-mandate");
        }
    };
    render() {
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="personal-details-wrap mt-110">
                        <form onSubmit={(e) => this.handleOnSubmit(e)}>
                            <div className="container mx-auto px-5">
                                <FormStep steps={this.steps} />
                                <PersonalDetailsCard />
                                <EmploymentDetailsCard />
                                <div className="relative w-full">
                                    <div className="mb-2 text-left">
                                        <label className="custom-inputs inline-flex items-start md:items-center">
                                            <input
                                                type="checkbox"
                                                onClick={(e) => {}}
                                                // checked={}
                                            />
                                            <span></span>
                                            <span
                                                className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg modal-open"
                                                onClick={() => {}}
                                            >
                                                I Confirm that the above account
                                                is fully KYC compliant with the
                                                above bank.
                                            </span>
                                        </label>
                                    </div>
                                    <span
                                        className={
                                            // !this.leadError["kycCompliantAgree"]
                                            //     ? "hidden"
                                            //     : "" +
                                            " error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm"
                                        }
                                    >
                                        {/* {this.leadError["kycCompliantAgree"]} */}
                                    </span>
                                </div>
                            </div>
                            <div className="container mx-auto px-5">
                                <BackContinueButton backPath="loan-details" />
                            </div>
                        </form>
                    </section>
                </div>
            </>
        );
    }
}

export default PersonalDetails;
